'use client'

import { useEffect, useState } from 'react'
import {
  LOADING_WATCHDOG_SCRIPT,
  LOADING_STUCK_MESSAGE_ID,
  HYDRATED_FLAG,
} from '@/lib/ui/loading-watchdog'

export default function Loading() {
  // eslint-disable-next-line gforce/route-only-reexport-or-segment-config -- app/loading.tsx は Next.js デフォルト loading UI で useState は GET fallback のみ
  const [elapsed, setElapsed] = useState(0)

  // commit された＝ハイドレートが生きている。インライン script のウォッチドッグへ知らせ、
  // 発火しても何もしないようにする（正常系の挙動を1ミリも変えないための要）。
  useEffect(() => {
    ;(window as unknown as Record<string, unknown>)[HYDRATED_FLAG] = true
  }, [])

  useEffect(() => {
    const id = setInterval(() => setElapsed((n) => n + 1), 1000)
    return () => clearInterval(id)
  }, [])

  // 20秒経過で自動リロード（ストリーミング途切れ等でスタックした場合の保険）
  useEffect(() => {
    if (elapsed >= 20) window.location.reload()
  }, [elapsed])

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface">
      {/* パース時点で走る保険。commit されない状況（= useEffect が動かない状況）でだけ働く。
          React 19 は script の文字列 children をエスケープせず出力するため、
          埋め込む値は静的リテラルのみ（lib/ui/loading-watchdog.ts 参照）。 */}
      <script>{LOADING_WATCHDOG_SCRIPT}</script>
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#2563EB] border-t-transparent" />
        <p className="text-sm text-muted-foreground">読み込み中...</p>
        {elapsed >= 10 && (
          <button
            onClick={() => window.location.reload()}
            className="mt-1 text-xs text-[#2563EB] underline"
          >
            再読み込みする
          </button>
        )}
        <div
          id={LOADING_STUCK_MESSAGE_ID}
          hidden
          className="mt-2 flex flex-col items-center gap-2 text-center"
        >
          <p className="text-sm text-destructive">読み込みに失敗しました</p>
          <button
            onClick={() => window.location.reload()}
            className="text-xs text-[#2563EB] underline"
          >
            再読み込みする
          </button>
        </div>
      </div>
    </div>
  )
}
